exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mat-tab-body-wrapper {\n    margin-top: 20px;\n}\n\n.ui-datascroller .ui-datascroller-content {\n    padding: 0;\n}\n\n.ui-widget-content {\n    border: 0;\n}\n\n.mat-tab-labels {\n    color: #000000;\n}\n\n.mat-tab-label:focus {\n    background-color: transparent;\n}\n\n.mat-tab-header,\n.mat-tab-nav-bar {\n    border-bottom-color: #b1b1b1;\n}\n\n.mat-tab-label {\n    white-space: nowrap;\n}\n\n.mat-tab-nav-bar .mat-tab-link {\n\tmin-width: 0px;\n\tpadding-left: 1rem;\n\tpadding-right: 1rem;\n}\n\n.mat-tab-nav-bar .mat-tab-link:hover {\n\tcolor: #211954;\n\topacity: 1;\n}\n\n.mat-tab-disabled {\n    opacity: .2;\n}\n\n.mat-tab-nav-bar .mat-tab-links {\n    display: block;\n}\n\n.red {\n    background: yellow;\n    font-weight: bolder;\n    display: initial;\n    padding: 0px 5px;\n}\n\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/css/tabs.css
// module id = 1619
// module chunks = 1